const Preloading = () => {
    return (
      <div className="loading-back position-fixed">
        <div className="loading-float position-absolute">
          <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
          <span role="status" className="loading-text">در حال بارگذاری اطلاعات ...</span>
        </div>
      </div>
    );
  }
  
  export default Preloading;